import React, {  useMemo } from "react";
import { BrowserRouter as Router,  Route,  Link, Switch,  useLocation} from "react-router-dom";
import Page from "@civicplus/preamble/lib/Page";
import { QaTestRoutes } from "./Routes";
import Dashboard from "./views/Dashboard";
import BugReporting from "./views/BugReporting";
import DashboardIcon from "@material-ui/icons/Dashboard";
import PreambleLink from "@civicplus/preamble/lib/Link";
import ViewListIcon from "@material-ui/icons/ViewList";
import UITest from "./views/UITest";
import TestPlanning from "./views/TestPlanning";

const App = () => {
    let location = useLocation();

    const navSectionsByUser = useMemo(() => {
        const navSections: any = {
            Root: {
                title: "Section 1",
                items: {
                    Dashboard: {
                        title: "Dashboard",
                        icon: <DashboardIcon />,
                        component: (props: any) => (
                            <PreambleLink component={Link} {...props} to={QaTestRoutes.dashboard} />
                        ),
                    },
                    UITest: {
                        title: "UI Test",
                        icon: <DashboardIcon />,
                        href: QaTestRoutes.uiTest,
                        component: (props: any) => <PreambleLink component={Link} {...props} to={props.href} />,
                    },
                    BugReporting: {
                        title: "Bug Reporting",
                        icon: <ViewListIcon />,
                        href: QaTestRoutes.bugReporting,
                        component: (props: any) => <PreambleLink component={Link} {...props} to={props.href} />,
                    },
                    TestCase: {
                        title: "Test Case",
                        icon: <ViewListIcon />,
                        href: QaTestRoutes.testCase,
                        component: (props: any) => <PreambleLink component={Link} {...props} to={props.href} />,
                    },
                },
            },
        };

        return navSections;
    }, []);

    return (
        <Router>
        <Page
            id="qatest-preamble-app"
            key={location.pathname}

            helpMenuOptions={{
                show: true,
                menuItems: [
                    {
                        display: "Pay Help Center",
                        action: () =>
                            window.open(
                                "https://www.platform.civicplus.help/hc/en-us/categories/1500000562061",
                                "_blank"
                            ),
                    },
                ],
            }}


            productNavSections={[{ title: "QA Test App" }]}
            navigationSections={navSectionsByUser}

        >
                <div style={{ width: "100%" }}>
                <Switch>
                        <Route path={QaTestRoutes.dashboard} exact component={Dashboard} />
                        <Route path={QaTestRoutes.uiTest} exact component={UITest} />
                        <Route path={QaTestRoutes.bugReporting} exact component={BugReporting} />
                        <Route path={QaTestRoutes.testCase} exact component={TestPlanning} />
                    </Switch>
                </div>
        </Page>
        </Router>
    );
};

export default App;
